var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#ED79AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1917 5.02256L12.1399 6.08175C11.7609 5.69846 11.3096 5.39423 10.8121 5.18673C10.3146 4.97922 9.78089 4.87256 9.24187 4.87294C7.03969 4.87294 5.2425 6.62231 5.148 8.81606H5.1435V12.8222C4.18453 11.7806 3.65347 10.4158 3.65625 9C3.65625 5.89331 6.15712 3.375 9.24187 3.375C9.97654 3.37448 10.704 3.51985 11.382 3.80267C12.0601 4.0855 12.6752 4.50014 13.1917 5.02256ZM13.1917 12.9774C12.1707 14.0105 10.7853 14.602 9.333 14.625V13.1265C10.3899 13.1036 11.3965 12.6705 12.1399 11.9188L13.1917 12.9774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57056 13.941V8.81662H6.5745C6.65325 7.35131 7.85812 6.1875 9.333 6.1875C10.8585 6.1875 12.0954 7.43288 12.0954 8.96962C12.0954 10.5058 10.8585 11.7512 9.33356 11.7512C8.84224 11.752 8.35978 11.6205 7.93687 11.3704V14.4703C7.45998 14.3555 7.00051 14.1771 6.57056 13.941ZM9.333 10.3759C9.51705 10.3753 9.69919 10.3384 9.869 10.2674C10.0388 10.1964 10.193 10.0927 10.3227 9.9621C10.4524 9.83151 10.5551 9.67664 10.6249 9.50635C10.6947 9.33606 10.7304 9.15368 10.7297 8.96962C10.7297 8.19281 10.1042 7.56337 9.333 7.56337C9.14899 7.56404 8.96692 7.60094 8.79717 7.67197C8.62742 7.743 8.47333 7.84677 8.34369 7.97735C8.21405 8.10793 8.11139 8.26277 8.04159 8.43303C7.97179 8.60328 7.93621 8.78562 7.93687 8.96962C7.93687 9.74588 8.56181 10.3759 9.333 10.3759Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPink);
export default __webpack_public_path__ + "static/media/pink.08fd37c35b29875997c37a29e3b737c6.svg";
export { ForwardRef as ReactComponent };